import classNames from 'classnames'

import styles from './Counter.module.scss'
import { CounterMinusIcon } from './icons/CounterMinusIcon'
import { CounterPlusIcon } from './icons/CounterPlusIcon'
import { QuestInputsLayout } from '@shared'
import { JSX, useState } from 'react'

type Props = {
  quantity: number
  onQuantityChange: (quantity: number) => void
  className?: string
  step?: number
  sufix?: JSX.Element | string
  blockMessage?: string
}

const CounterButton = ({
  type,
  onClick,
}: {
  type: 'decrement' | 'increment'
  onClick: () => void
}) => {
  const content =
    type === 'decrement' ? (
      <CounterMinusIcon />
    ) : (
      <CounterPlusIcon />
    )

  return (
    <div className={styles.button} onClick={onClick}>
      <div className={styles.buttonInner}>{content}</div>
    </div>
  )
}

export const Counter = ({
  className,
  quantity,
  onQuantityChange,
  sufix = "", 
  step = 1,
  blockMessage
}: Props) => {
  const [isLayoutOpen, setIsLayoutOpen] = useState(false)

  return (
    <div className={classNames(styles.root, className)}>
      <CounterButton
        type="decrement"
        onClick={() => !blockMessage && onQuantityChange(quantity - step)}
      />
      <div 
        className={classNames(styles.quantity, {
          [styles.disabled]: blockMessage
        })} 
        onClick={() => !blockMessage && setIsLayoutOpen(true)}
      >
          {blockMessage || quantity} {sufix}
      </div>
      <CounterButton
        type="increment"
        onClick={() => !blockMessage && onQuantityChange(quantity + step)}
      />
      <QuestInputsLayout 
        className={styles.secretInputs}
        keyBoardType='numeric'
        state={isLayoutOpen}
        value={quantity.toString()}
        setValue={(value) => onQuantityChange(Number(value))}
        handleComplete={(value) => onQuantityChange(Number(value))}
        onCloseTrigger={() => setIsLayoutOpen(false)}
      />
    </div>
  )
}
